import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const CenteredText = () => import(/* webpackChunkName: "snippet-items-centered-text" */ 'components/SnippetTemplate/Items/CenteredText')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(CenteredText, {props: eval(this.elemId)})
        })
    }
}
